import { ActionTree, GetterTree, MutationTree } from "vuex";
import { CouponStoreType } from "@/types/CouponTypes";

const state: CouponStoreType = {
  couponAmountUsed: 0,
  couponDiscount: "",
  selectedPaymentMode: "CREDIT_CARD",
  coupon: {
    id: "",
    code: "",
    couponType: "",
    status: "",
    description: "",
    couponRescue: {
      couponRescueType: "",
      hasDiscountMoney: "",
    },
    lifecycle: {
      startDate: "",
      endtDate: "",
    },
    amountAvailable: 0,
    userLimit: 0,
    channels: [],
    reward: {
      type: "",
      discounts: [
        {
          value: {
            amount: 0,
            scale: 0,
            currency: "",
          },
        },
      ],
    },
  },
};

const getters: GetterTree<CouponStoreType, any> = {
  couponDiscount: (st) => st.couponDiscount,
  selectedCouponCode: (st) => st.coupon.code,
  selectedPaymentMode: (st) => st.selectedPaymentMode,
};

const mutations: MutationTree<CouponStoreType> = {
  setCouponDiscount(st: CouponStoreType, couponDiscount) {
    st.couponDiscount = couponDiscount;
  },
  setSelectedCouponCode(st: CouponStoreType, selectedCoupon) {
    st.coupon.code = selectedCoupon;
  },
  setPaymentModeSelected(st: CouponStoreType, selectedPaymentMode) {
    st.selectedPaymentMode = selectedPaymentMode;
  },
};

const actions: ActionTree<CouponStoreType, any> = {
  setCouponDiscount({ commit }, couponDiscount) {
    commit("setCouponDiscount", couponDiscount);
  },
  setPaymentModeSelected({ commit }, selectedPaymentMode) {
    commit("setPaymentModeSelected", selectedPaymentMode);
  },
  setSelectedCouponCode({ commit }, selectedCoupon) {
    commit("setSelectedCouponCode", selectedCoupon);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
